import Blue from "~/core";

new Blue({
  name: "Illegal Dumping Report Form",
  selector: ".illegal-dumping-report__form",
  setup(form) {
    let submittedTrackingNumber = document.querySelector(".illegal-dumping-report__tracking-number-input");
    let submitButton = form.querySelector(".form__submit");

    this.$addEvents(submitButton, 'click', function () {
      if (!submittedTrackingNumber.value) {
        return;
      }

      window.location.href = `?trackingId=${submittedTrackingNumber.value}`;
    });
  }
});

var jurisElement = document.querySelectorAll('[id*="Jurisdiction_Value"]');
jurisElement.forEach(function(input) {
  if(input.value !== ''){
    input.readOnly = true;
  }
});
